import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { styled } from '@mui/material/styles';
import React from 'react';

// Fixed gold, deliberately not brand-derived so a favorite reads the same on every brand.
const FAVORITE_GOLD = '#FFD700';

const InactiveStar = styled(StarBorderIcon)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export type FavoriteStarTone = 'gold' | 'warning';

export const FavoriteStarIcon = ({
  favorite,
  tone = 'gold',
  fontSize = 'inherit',
}: {
  favorite: boolean;
  tone?: FavoriteStarTone;
  fontSize?: SvgIconProps['fontSize'];
}) => {
  if (!favorite) return <InactiveStar fontSize={fontSize} />;
  return tone === 'warning'
    ? <StarIcon fontSize={fontSize} color="warning" />
    : <StarIcon fontSize={fontSize} htmlColor={FAVORITE_GOLD} />;
};
